import { Button } from "antd";
import React from "react";
import { useForm, useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ApiTienda } from "../../API/ConfigApi";
import FooterAdmin from "../../components/FooterAdmin";
import { InputNumberT, InputT } from "../../components/FormularioTeclas";

function SendCode(props) {
  const {
    handleSubmit,
    control,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();


  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div
          style={{
            width: "300px",
            display: "flex",
            flexDirection: "column",
            padding: "25px 20px",
            borderRadius: "10px",
            border: "1px solid #D8D8D8",
          }}
        >
          <h2
            style={{
              textAlign: "center",
              fontWeight: 900,
              fontSize: "30px",
              color: "#7d07f3",
            }}
          >
            Ingresa tu código de recuperación
          </h2>
          <p style={{ textAlign: "center" }}>
            Ingresa el código que recibiste en tu celular para poder recuperar
            tu contraseña
          </p>

          <form onSubmit={handleSubmit(props.sendCodeNumber)}>
            <InputNumberT
              name="cellphoneCode"
              status={errors?.cellphoneCode?.type === "required" ? "error" : ""}
              control={control}
              rules={{ required: true }}
              ancho="100%"
              borderRadius={"7px"}
            ></InputNumberT>
            {errors?.cellphoneCode?.type === "required" && (
              <span style={{ color: "red" }}>Campo requerido</span>
            )}
            <div>
              <Button
                style={{
                  width: "100%",
                  margin: "15px 0 0 0",
                  borderRadius: "7px",
                  backgroundColor: "#7d07f3",
                  color: "#fff",
                }}
                htmlType="submit"

                loading={props.loadingAction.loadingCode}
              >
                Enviar código
              </Button>
            </div>
            <div>
              <Button
                style={{
                  width: "100%",
                  margin: "15px 0 0 0",
                  borderRadius: "7px",
              
                  color: "#000",
                }}

                loading={props.loadingAction.loadingNumber}
                htmlType="button"
                onClick={()=>{
                  props.recoveryPasswordUser(getValues())
                  setValue("cellphoneCode","")
                }}
              >
                Reenviar código
              </Button>
            </div>
          </form>
        </div>
      </div>
      <FooterAdmin />
    </div>
  );
}

export default SendCode;
